// extracted by mini-css-extract-plugin
export var changeIcon = "_6u-4";
export var container = "_6u-0";
export var divider = "_6u-7";
export var externalLinkIcon = "_6u-1";
export var green = "_6u-5";
export var helpCircleIcon = "_6u-3";
export var iconButton = "_6u-2";
export var red = "_6u-6";